import { render, staticRenderFns } from "./PreCompressionForce.vue?vue&type=template&id=67a353ca&scoped=true&"
import script from "./PreCompressionForce.vue?vue&type=script&lang=ts&"
export * from "./PreCompressionForce.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67a353ca",
  null
  
)

export default component.exports